import { tokens } from '@sparkpost/design-tokens';

export default {
  new: {
    OGFill: '#88E2E7',
    hibanaFill: tokens.color_blue_600,
    OGStroke: '#88E2E7',
    hibanaStroke: tokens.color_blue_600,
    label: 'New',
    description: 'Never engaged, first email in last 7 days'
  },
  uneng: {
    OGFill: '#50CFDA',
    hibanaFill: tokens.color_yellow_600,
    OGStroke: '#50CFDA',
    hibanaStroke: tokens.color_yellow_600,
    label: 'Never Engaged',
    description: '365+ days since last engagement'
  },
  '365d': {
    OGFill: '#29B9C7',
    hibanaFill: tokens.color_green_600,
    OGStroke: '#29B9C7',
    hibanaStroke: tokens.color_green_600,
    label: 'Not Recently Engaged',
    description: '90-365 days since last engagement'
  },
  '90d': {
    OGFill: '#219EA8',
    hibanaFill: tokens.color_purple_600,
    OGStroke: '#219EA8',
    hibanaStroke: tokens.color_purple_600,
    label: 'Semi Recently Engaged',
    description: '14-90 days since last engagement'
  },
  '14d': {
    OGFill: '#1A838B',
    hibanaFill: tokens.color_teal_600,
    OGStroke: '#1A838B',
    hibanaStroke: tokens.color_teal_600,
    label: 'Recently Engaged',
    description: '0-14 days since last engagement'
  }
};
